(function () {
  const instanceKey = '__ynsScrollingFeaturesBarInstance';
  if (window[instanceKey]) return;

  class ScrollingFeaturesBar {
    constructor(options = {}) {
      this.options = options;
      this.init();
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
      } else {
        this.setup();
      }

      window.addEventListener('resize', () => this.adjustFeaturesTrack());
      if (document.fonts) {
        document.fonts.ready.then(() => this.setup());
      }
    }

    setup() {
      const allSections = document.querySelectorAll('[class*="section-"]');
      allSections.forEach((section) => {
        if (section.querySelector('.features-track')) {
          this.initSection(section);
        }
      });
    }

    initSection(section) {
      const trackContainer = section.querySelector('.features-track-container');
      const track = section.querySelector('.features-track');
      const featureItems = track?.querySelector('.feature-items');
      if (!trackContainer || !track || !featureItems) return;

      this.configureScrollingAnimation(section, track);
      this.adjustFeaturesTrack(section, trackContainer, track, featureItems);
    }

    configureScrollingAnimation(section, track) {
      const pauseOnHover = section.classList.contains('pause-on-hover');
      if (pauseOnHover && !track.dataset.ynsHoverBound) {
        track.dataset.ynsHoverBound = 'true';
        track.addEventListener('mouseenter', () => {
          track.style.animationPlayState = 'paused';
        });
        track.addEventListener('mouseleave', () => {
          track.style.animationPlayState = 'running';
        });
      }
    }

    adjustFeaturesTrack(section, trackContainer, track, featureItems) {
      if (!section) {
        const allSections = document.querySelectorAll('[class*="section-"]');
        allSections.forEach((item) => {
          if (item.querySelector('.features-track')) {
            const container = item.querySelector('.features-track-container');
            const currentTrack = item.querySelector('.features-track');
            const items = currentTrack?.querySelector('.feature-items');
            if (container && currentTrack && items) {
              this.adjustFeaturesTrack(item, container, currentTrack, items);
            }
          }
        });
        return;
      }

      if (!trackContainer || !track || !featureItems) return;
      const featureItemsWidth = featureItems.offsetWidth;
      const totalWidth = featureItemsWidth * 4;
      if (totalWidth > 0) track.style.width = `${totalWidth}px`;
      trackContainer.style.height = `${featureItems.offsetHeight}px`;
    }
  }

  const instance = new ScrollingFeaturesBar();
  window[instanceKey] = instance;
})();